import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  style: {
    "height": "1080px",
    "width": "1920px",
    "background": "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
    "padding": "20px"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "max-width": "800px",
    "margin": "0 auto"
  }
};
const _hoisted_3 = {
  style: {
    "background": "white",
    "border-radius": "16px",
    "box-shadow": "0 10px 25px rgba(0, 0, 0, 0.1)",
    "padding": "40px",
    "text-align": "center"
  }
};
const _hoisted_4 = {
  key: 1,
  style: {
    "max-width": "900px",
    "margin": "0 auto"
  }
};
const _hoisted_5 = {
  style: {
    "background": "white",
    "border-radius": "16px",
    "box-shadow": "0 10px 25px rgba(0, 0, 0, 0.1)",
    "padding": "32px",
    "margin-bottom": "24px"
  }
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "flex-wrap": "wrap",
    "gap": "16px",
    "margin-bottom": "24px"
  }
};
const _hoisted_7 = {
  style: {
    "font-size": "20px",
    "font-weight": "700",
    "color": "#1e293b"
  }
};
const _hoisted_8 = {
  style: {
    "color": "#64748b",
    "font-size": "14px",
    "margin-top": "4px"
  }
};
const _hoisted_9 = {
  style: {
    "text-align": "right"
  }
};
const _hoisted_10 = {
  style: {
    "font-size": "20px",
    "font-weight": "700",
    "color": "#3b82f6"
  }
};
const _hoisted_11 = {
  key: 0,
  style: {
    "margin-bottom": "24px",
    "padding": "20px",
    "background": "#f8fafc",
    "border-radius": "12px",
    "max-height": "300px",
    "overflow-y": "auto",
    "line-height": "1.6",
    "color": "#334155",
    "font-size": "18px"
  }
};
const _hoisted_12 = {
  key: 1,
  style: {
    "margin-bottom": "24px",
    "text-align": "center"
  }
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  style: {
    "margin-bottom": "24px",
    "font-size": "18px",
    "font-weight": "500",
    "color": "#1e293b",
    "line-height": "1.5"
  }
};
const _hoisted_15 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "gap": "12px"
  }
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "12px"
  }
};
const _hoisted_18 = {
  style: {
    "width": "24px",
    "height": "24px",
    "border": "2px solid #94a3b8",
    "border-radius": "50%",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "font-weight": "600",
    "color": "#64748b"
  }
};
const _hoisted_19 = {
  style: {
    "flex": "1",
    "font-size": "15px",
    "color": "#334155"
  }
};
const _hoisted_20 = {
  key: 0,
  style: {
    "color": "#10b981",
    "font-weight": "700",
    "font-size": "18px"
  }
};
const _hoisted_21 = {
  key: 1,
  style: {
    "color": "#ef4444",
    "font-weight": "700",
    "font-size": "18px"
  }
};
const _hoisted_22 = {
  style: {
    "margin-top": "20px",
    "display": "flex",
    "align-items": "center",
    "color": "#64748b",
    "font-size": "14px"
  }
};
const _hoisted_23 = {
  style: {
    "margin-left": "8px"
  }
};
const _hoisted_24 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "gap": "16px"
  }
};
const _hoisted_25 = ["disabled"];
const _hoisted_26 = ["disabled"];
const _hoisted_27 = {
  key: 2,
  style: {
    "max-width": "600px",
    "margin": "0 auto"
  }
};
const _hoisted_28 = {
  style: {
    "background": "white",
    "border-radius": "16px",
    "box-shadow": "0 10px 25px rgba(0, 0, 0, 0.1)",
    "padding": "40px",
    "text-align": "center"
  }
};
const _hoisted_29 = {
  style: {
    "margin-bottom": "24px"
  }
};
const _hoisted_30 = {
  style: {
    "color": "#64748b",
    "font-size": "18px"
  }
};
const _hoisted_31 = {
  style: {
    "background": "#f8fafc",
    "border-radius": "12px",
    "padding": "24px",
    "margin-bottom": "24px"
  }
};
const _hoisted_32 = {
  style: {
    "display": "grid",
    "grid-template-columns": "repeat(auto-fit, minmax(120px, 1fr))",
    "gap": "16px",
    "text-align": "center"
  }
};
const _hoisted_33 = {
  style: {
    "padding": "16px",
    "background": "#dbeafe",
    "border-radius": "12px"
  }
};
const _hoisted_34 = {
  style: {
    "font-size": "18px",
    "font-weight": "700",
    "color": "#1e40af"
  }
};
const _hoisted_35 = {
  style: {
    "padding": "16px",
    "background": "#ede9fe",
    "border-radius": "12px"
  }
};
const _hoisted_36 = {
  style: {
    "font-size": "18px",
    "font-weight": "700",
    "color": "#5b21b6"
  }
};
const _hoisted_37 = {
  style: {
    "padding": "16px",
    "background": "#dcfce7",
    "border-radius": "12px"
  }
};
const _hoisted_38 = {
  style: {
    "font-size": "18px",
    "font-weight": "700",
    "color": "#166534"
  }
};
const _hoisted_39 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "gap": "16px"
  }
};
const _hoisted_40 = {
  key: 3,
  style: {
    "position": "fixed",
    "top": "0",
    "left": "0",
    "width": "100%",
    "height": "100%",
    "background": "rgba(0, 0, 0, 0.5)",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "z-index": "1000"
  }
};
const _hoisted_41 = {
  style: {
    "background": "white",
    "border-radius": "16px",
    "width": "90%",
    "max-width": "800px",
    "max-height": "90vh",
    "overflow-y": "auto"
  }
};
const _hoisted_42 = {
  style: {
    "padding": "24px",
    "border-bottom": "1px solid #e2e8f0",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_43 = {
  style: {
    "padding": "24px",
    "max-height": "calc(90vh - 120px)",
    "overflow-y": "auto"
  }
};
const _hoisted_44 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "start",
    "margin-bottom": "16px"
  }
};
const _hoisted_45 = {
  style: {
    "font-weight": "600",
    "color": "#1e293b",
    "font-size": "16px"
  }
};
const _hoisted_46 = {
  key: 0,
  style: {
    "margin-bottom": "16px",
    "padding": "16px",
    "background": "#f8fafc",
    "border-radius": "8px",
    "font-size": "14px",
    "line-height": "1.5",
    "color": "#334155"
  }
};
const _hoisted_47 = {
  style: {
    "margin-bottom": "16px",
    "font-weight": "500",
    "color": "#1e293b",
    "font-size": "15px"
  }
};
const _hoisted_48 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "gap": "8px",
    "margin-bottom": "16px"
  }
};
const _hoisted_49 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "8px"
  }
};
const _hoisted_50 = {
  style: {
    "font-weight": "600",
    "color": "#334155"
  }
};
const _hoisted_51 = {
  style: {
    "color": "#334155",
    "font-size": "14px"
  }
};
const _hoisted_52 = {
  key: 0,
  style: {
    "color": "#10b981",
    "font-weight": "700",
    "margin-left": "auto"
  }
};
const _hoisted_53 = {
  key: 1,
  style: {
    "color": "#ef4444",
    "font-weight": "700",
    "margin-left": "auto"
  }
};
const _hoisted_54 = {
  style: {
    "padding": "12px",
    "background": "#dbeafe",
    "border-radius": "8px"
  }
};
const _hoisted_55 = {
  style: {
    "color": "#1e40af",
    "font-weight": "600",
    "font-size": "14px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!$data.examStarted && !$data.showResults ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[6] || (_cache[6] = _createStaticVNode("<div style=\"background:white;border-radius:16px;box-shadow:0 10px 25px rgba(0, 0, 0, 0.1);padding:40px;margin-bottom:24px;text-align:center;\"><h1 style=\"font-size:28px;font-weight:700;color:#1e293b;margin-bottom:8px;\"> SAT英语在线模拟考试 </h1><div style=\"background:#dbeafe;border-radius:12px;padding:20px;margin-top:24px;text-align:left;\"><h3 style=\"font-weight:600;color:#1e40af;margin-bottom:12px;font-size:16px;\"> 考试说明: </h3><ul style=\"color:#1e3a8a;font-size:14px;padding-left:20px;margin:0;\"><li style=\"margin-bottom:6px;\">前10题为1-3星难度的基础题目</li><li style=\"margin-bottom:6px;\">根据前10题得分决定后续2题难度</li><li style=\"margin-bottom:6px;\">得分≥80%：后续2题为5星难度</li><li style=\"margin-bottom:6px;\">得分&lt;80%：后续2题为4星难度</li><li>总分120分，每题10分</li></ul></div></div>", 1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.startExam && $options.startExam(...args)),
    style: {
      "width": "100%",
      "background": "linear-gradient(90deg, #3b82f6 0%, #1d4ed8 100%)",
      "color": "white",
      "font-weight": "600",
      "padding": "16px 32px",
      "border-radius": "12px",
      "border": "none",
      "cursor": "pointer",
      "font-size": "18px",
      "transition": "all 0.3s ease",
      "box-shadow": "0 4px 12px rgba(59, 130, 246, 0.3)"
    }
  }, " 开始考试 ")])])) : !$data.showResults ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createElementVNode("h2", _hoisted_7, " 第 " + _toDisplayString($data.currentQuestionIndex + 1) + " 题 / " + _toDisplayString($options.totalQuestions), 1), _createElementVNode("p", _hoisted_8, " 当前阶段: " + _toDisplayString($data.examPhase === "easy" ? "基础题目" : "挑战题目"), 1)]), _createElementVNode("div", _hoisted_9, [_cache[7] || (_cache[7] = _createElementVNode("div", {
    style: {
      "color": "#64748b",
      "font-size": "14px",
      "margin-bottom": "4px"
    }
  }, " 得分 ", -1)), _createElementVNode("div", _hoisted_10, _toDisplayString($data.score) + " / " + _toDisplayString($options.maxScore), 1)])]), $options.currentQuestion.description ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($options.currentQuestion.description), 1)) : _createCommentVNode("", true), $options.currentQuestion.imagesUrl ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("img", {
    src: $options.currentQuestion.imagesUrl,
    alt: "题目配图",
    style: {
      "max-width": "100%",
      "height": "auto",
      "border-radius": "8px",
      "max-height": "250px",
      "object-fit": "contain"
    }
  }, null, 8, _hoisted_13)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, _toDisplayString($options.currentQuestion.question), 1), _createElementVNode("div", _hoisted_15, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['A', 'B', 'C', 'D'], (option, key) => {
    return _createElementVNode("div", {
      key: key,
      onClick: $event => $options.selectAnswer(key),
      style: _normalizeStyle({
        padding: '16px',
        borderRadius: '12px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        borderColor: $data.selectedAnswer === key ? '#3b82f6' : $data.showAnswer && key === $options.currentQuestion.answer ? '#10b981' : $data.showAnswer && $data.selectedAnswer === key && key !== $options.currentQuestion.answer ? '#ef4444' : '#e2e8f0',
        backgroundColor: $data.selectedAnswer === key ? '#eff6ff' : $data.showAnswer && key === $options.currentQuestion.answer ? '#f0fdf4' : $data.showAnswer && $data.selectedAnswer === key && key !== $options.currentQuestion.answer ? '#fef2f2' : 'white',
        borderWidth: '2px',
        borderStyle: 'solid'
      })
    }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(option), 1), _createElementVNode("span", _hoisted_19, _toDisplayString($options.getOptionText(key)), 1), $data.showAnswer && key === $options.currentQuestion.answer ? (_openBlock(), _createElementBlock("div", _hoisted_20, " ✓ ")) : _createCommentVNode("", true), $data.showAnswer && $data.selectedAnswer === key && key !== $options.currentQuestion.answer ? (_openBlock(), _createElementBlock("div", _hoisted_21, " ✗ ")) : _createCommentVNode("", true)])], 12, _hoisted_16);
  }), 64))]), _createElementVNode("div", _hoisted_22, [_cache[8] || (_cache[8] = _createElementVNode("span", {
    style: {
      "margin-right": "8px"
    }
  }, "难度:", -1)), _cache[9] || (_cache[9] = _createElementVNode("div", {
    style: {
      "display": "flex",
      "gap": "2px"
    }
  }, null, -1)), _createElementVNode("span", _hoisted_23, _toDisplayString($options.currentQuestion.difficulty) + "星", 1)])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("button", {
    onClick: _cache[1] || (_cache[1] = (...args) => $options.prevQuestion && $options.prevQuestion(...args)),
    disabled: $data.currentQuestionIndex === 0,
    style: _normalizeStyle({
      flex: '1',
      padding: '14px 24px',
      background: $data.currentQuestionIndex === 0 ? '#cbd5e1' : '#94a3b8',
      color: 'white',
      fontWeight: '600',
      border: 'none',
      borderRadius: '12px',
      cursor: $data.currentQuestionIndex === 0 ? 'not-allowed' : 'pointer',
      fontSize: '16px',
      transition: 'all 0.2s ease',
      opacity: $data.currentQuestionIndex === 0 ? '0.5' : '1'
    })
  }, " 上一题 ", 12, _hoisted_25), _createElementVNode("button", {
    onClick: _cache[2] || (_cache[2] = (...args) => $options.nextQuestion && $options.nextQuestion(...args)),
    disabled: !$data.selectedAnswer,
    style: _normalizeStyle({
      flex: '1',
      padding: '14px 24px',
      background: !$data.selectedAnswer ? '#9ae6b4' : 'linear-gradient(90deg, #10b981 0%, #059669 100%)',
      color: 'white',
      fontWeight: '600',
      border: 'none',
      borderRadius: '12px',
      cursor: !$data.selectedAnswer ? 'not-allowed' : 'pointer',
      fontSize: '16px',
      transition: 'all 0.2s ease',
      boxShadow: !$data.selectedAnswer ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.3)',
      opacity: !$data.selectedAnswer ? '0.5' : '1'
    })
  }, _toDisplayString($data.currentQuestionIndex === $options.totalQuestions - 1 ? "提交考试" : "下一题"), 13, _hoisted_26)])])) : (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_cache[10] || (_cache[10] = _createElementVNode("h2", {
    style: {
      "font-size": "28px",
      "font-weight": "700",
      "color": "#1e293b",
      "margin-bottom": "8px"
    }
  }, " 考试完成！ ", -1)), _createElementVNode("div", {
    style: _normalizeStyle({
      fontSize: '48px',
      fontWeight: '700',
      marginBottom: '16px',
      color: $options.getScoreColor()
    })
  }, _toDisplayString($data.finalScore) + "% ", 5), _createElementVNode("p", _hoisted_30, " 总分: " + _toDisplayString($data.score) + " / " + _toDisplayString($options.maxScore), 1)]), _createElementVNode("div", _hoisted_31, [_cache[14] || (_cache[14] = _createElementVNode("h3", {
    style: {
      "font-weight": "600",
      "color": "#334155",
      "margin-bottom": "16px",
      "font-size": "16px"
    }
  }, " 答题详情: ", -1)), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_cache[11] || (_cache[11] = _createElementVNode("div", {
    style: {
      "color": "#1e40af",
      "font-weight": "600",
      "font-size": "14px",
      "margin-bottom": "8px"
    }
  }, " 基础题目 ", -1)), _createElementVNode("div", _hoisted_34, _toDisplayString($data.easyCorrect) + " / 10 ", 1)]), _createElementVNode("div", _hoisted_35, [_cache[12] || (_cache[12] = _createElementVNode("div", {
    style: {
      "color": "#5b21b6",
      "font-weight": "600",
      "font-size": "14px",
      "margin-bottom": "8px"
    }
  }, " 挑战题目 ", -1)), _createElementVNode("div", _hoisted_36, _toDisplayString($data.hardCorrect) + " / 2 ", 1)]), _createElementVNode("div", _hoisted_37, [_cache[13] || (_cache[13] = _createElementVNode("div", {
    style: {
      "color": "#166534",
      "font-weight": "600",
      "font-size": "14px",
      "margin-bottom": "8px"
    }
  }, " 总体正确率 ", -1)), _createElementVNode("div", _hoisted_38, _toDisplayString($data.finalScore) + "% ", 1)])])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("button", {
    onClick: _cache[3] || (_cache[3] = (...args) => $options.reviewAnswers && $options.reviewAnswers(...args)),
    style: {
      "padding": "16px 32px",
      "background": "linear-gradient(90deg, #8b5cf6 0%, #7c3aed 100%)",
      "color": "white",
      "font-weight": "600",
      "border": "none",
      "border-radius": "12px",
      "cursor": "pointer",
      "font-size": "16px",
      "transition": "all 0.2s ease",
      "box-shadow": "0 4px 12px rgba(139, 92, 246, 0.3)"
    }
  }, " 查看答案解析 "), _createElementVNode("button", {
    onClick: _cache[4] || (_cache[4] = (...args) => $options.restartExam && $options.restartExam(...args)),
    style: {
      "padding": "16px 32px",
      "background": "linear-gradient(90deg, #64748b 0%, #475569 100%)",
      "color": "white",
      "font-weight": "600",
      "border": "none",
      "border-radius": "12px",
      "cursor": "pointer",
      "font-size": "16px",
      "transition": "all 0.2s ease",
      "box-shadow": "0 4px 12px rgba(100, 116, 139, 0.3)"
    }
  }, " 重新开始考试 ")])])])), $data.showReview ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_cache[15] || (_cache[15] = _createElementVNode("h3", {
    style: {
      "font-size": "20px",
      "font-weight": "700",
      "color": "#1e293b"
    }
  }, " 答案解析 ", -1)), _createElementVNode("button", {
    onClick: _cache[5] || (_cache[5] = $event => $data.showReview = false),
    style: {
      "background": "none",
      "border": "none",
      "font-size": "24px",
      "color": "#64748b",
      "cursor": "pointer",
      "width": "40px",
      "height": "40px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "8px",
      "transition": "background 0.2s"
    }
  }, " × ")]), _createElementVNode("div", _hoisted_43, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.allQuestions, (question, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: {
        "border-bottom": "1px solid #f1f5f9",
        "padding-bottom": "24px",
        "margin-bottom": "24px"
      }
    }, [_createElementVNode("div", _hoisted_44, [_createElementVNode("h4", _hoisted_45, " 第 " + _toDisplayString(index + 1) + " 题 ", 1), _createElementVNode("span", {
      style: _normalizeStyle({
        fontWeight: '700',
        fontSize: '18px',
        color: $options.getUserAnswer(index) === question.answer ? '#10b981' : '#ef4444'
      })
    }, _toDisplayString($options.getUserAnswer(index) === question.answer ? "✓" : "✗"), 5)]), question.description ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(question.description), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_47, _toDisplayString(question.question), 1), _createElementVNode("div", _hoisted_48, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['A', 'B', 'C', 'D'], (option, key) => {
      return _createElementVNode("div", {
        key: key,
        style: _normalizeStyle([{
          "padding": "12px",
          "border-radius": "8px"
        }, {
          backgroundColor: key === question.answer ? '#f0fdf4' : $options.getUserAnswer(index) === key && key !== question.answer ? '#fef2f2' : '#f8fafc',
          border: key === question.answer ? '2px solid #10b981' : $options.getUserAnswer(index) === key && key !== question.answer ? '2px solid #ef4444' : '1px solid #e2e8f0'
        }])
      }, [_createElementVNode("div", _hoisted_49, [_createElementVNode("span", _hoisted_50, _toDisplayString(option) + ".", 1), _createElementVNode("span", _hoisted_51, _toDisplayString($options.getOptionFromQuestion(question, key)), 1), key === question.answer ? (_openBlock(), _createElementBlock("span", _hoisted_52, "✓")) : _createCommentVNode("", true), $options.getUserAnswer(index) === key && key !== question.answer ? (_openBlock(), _createElementBlock("span", _hoisted_53, "✗")) : _createCommentVNode("", true)])], 4);
    }), 64))]), _createElementVNode("div", _hoisted_54, [_createElementVNode("span", _hoisted_55, "正确答案: " + _toDisplayString(question.answer), 1)])]);
  }), 128))])])])) : _createCommentVNode("", true)]);
}